import React, { useEffect, useState } from 'react'
import i18n from 'utils/i18n'
import ListItem from 'components/atoms/ListItem'
import { listArrow } from 'styles/list'
import LoadingComponent from 'components/atoms/Loading'
import ThemedBlock from 'components/atoms/ThemedBlock'
import Text from "theme/Text";
import { textStyles } from 'styles/text'
import ThemedList from 'components/atoms/ThemedList'
import Button from 'theme/Button'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import ThemedContainerButton from 'components/atoms/ThemedContainerButton'
import { AppRoutes } from 'navigations/app-routes'
import { useNavigation } from '@react-navigation/native'
import FetchReports from 'utils/fetch/FetchReports'

const ManagementReportsScheduleTab = () => {
	
	const navigation = useNavigation();
	
	const [ loading, setLoading ] = useState( true )
	const [ reports, setReports ] = useState([] )
	
	const onPressAdd = () => {
		navigation.navigate( AppRoutes.MANAGEMENT_REPORTS_SCHEDULE_EDIT, {
			guid: null
		})
	}
	
	const onPressView = ( item ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_REPORTS_SCHEDULE_EDIT, {
			guid: item.guid
		})
	}
	
	const fetch = () => {
		FetchReports.fetchAll({
			callbackSuccess: result => {
				setReports( result )
				setLoading( false )
			},
			callbackError: () => {
				setLoading( false )
			},
			callbackStart: () => {
				setLoading( true )
			}
		})
	}
	
	const renderItem = ( { item } ) => {
		// Create the title
		const subtitle = [
			i18n.t(`management:form.email.title`) +': '+ item.email,
			i18n.t(`management:form.time.title`) +': '+ item.time,
			i18n.t(`management:form.for_date.title`) +': '+ (item.for_date ?? i18n.t('management:generic.today')),
		];
		
		let title = item.type;
		switch( item.type ) {
			case 'bookings':
				title = i18n.t(`management:reports.bookings_on_day.title`)
				break;
				
			case 'lunches':
				title = i18n.t(`management:reports.lunches_on_day.title`)
				break;
				
			case 'parkings':
				title = i18n.t(`management:reports.parking_on_day.title`)
				break;
		}
		
		return (
			<ListItem
				title={ title }
				subtitle={ subtitle.join("\r\n") }
				title_add_active_tag={ true }
				item={ item }
				accessoryRight={ listArrow }
				onPress={ onPressView }
			/>
		)
	}
	
	useEffect( () => {
		return fetch();
	}, [] )
	
	let content = <LoadingComponent />;
	if( !loading ) {
		
		content = (
			<ThemedBlock transparent mediumPadding>
				<Text style={ textStyles.textCenter }>
					{ i18n.t( 'management:generic.no_results' ) }
				</Text>
			</ThemedBlock>
		)
		
		if( reports.length > 0 ) {
			content = (
				<ThemedList
					data={ reports }
					renderItem={ renderItem.bind( this ) }
					scrollEnabled={ false }
				/>
			)
		}
	}
	
	return (
		<ThemedContainerButton
			buttons={(
				<Button
					onPress={ onPressAdd }
					icon={ <Icon icon={ IconSystemConstants.PLUS } /> }>
					
					{ i18n.t( 'management:generic.add') }
				</Button>
			)}>
			
			{ content }
		</ThemedContainerButton>
	)
}

export default ManagementReportsScheduleTab
